export const wFacebookCommentMetaData = {
    isRepeatable: false
}
